import { fetchToken } from "../../../common/FetchCookie"
import { BASE_URL, CANDIDATE, CANDIDATE_ACTIVE_RESUME, CANDIDATE_RESUME_BUILDER } from "../../../common/URLs"

export const fetchCandidateActiveResumeBuilder = async () => {
    const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_ACTIVE_RESUME}`

    try {
        const token = await fetchToken()
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
        const data = response.json()
        return data
    } catch (error) {
        console.log("error", error)
    }
}

export const CandidateResumeBuilder = async (resumeBuilderUuid) => {
    const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_RESUME_BUILDER}`

    try {
        const token = await fetchToken()
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                resume_builder_uuid: resumeBuilderUuid,
            }),
        })

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        return data
    } catch (error) {
        console.error("Error in CandidateResumeBuilder:", error)
        throw error
    }
}


export const fetchCandidateTotalResumes = async () => {
    const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_RESUME_BUILDER}`

    try {
        const token = await fetchToken()
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        })

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        console.log("API Response:", data) // Add this for debugging
        return data
    } catch (error) {
        console.error("Error in fetchCandidateResumeBuilder:", error)
        throw error
    }
}
